import { render, staticRenderFns } from "./SearchesPerDay.vue?vue&type=template&id=31163577&scoped=true"
import script from "./SearchesPerDay.vue?vue&type=script&lang=ts"
export * from "./SearchesPerDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31163577",
  null
  
)

export default component.exports